import { Controller } from "@hotwired/stimulus"

const DEBUG = true
const log = (...args) => DEBUG && console.debug("[HeaderMenu]", ...args)

export default class extends Controller {
  open() {
    log("switch staff clicked -> closing dropdown")
    this.blurActiveElement()
    this.closeParentDropdown()
    log("opening pin modal")
    requestAnimationFrame(() => {
      window.dispatchEvent(new CustomEvent("staff-switch:show"))
    })
  }

  blurActiveElement() {
    if (document.activeElement && typeof document.activeElement.blur === "function") {
      document.activeElement.blur()
    }
  }

  closeParentDropdown() {
    const dropdownEl = this.element.closest('[data-controller*="railsui-dropdown"]')
    if (!dropdownEl) return
    const ctrl = this.application.getControllerForElementAndIdentifier(dropdownEl, "railsui-dropdown")
    if (ctrl?.leave) {
      ctrl.leave()
      if (typeof ctrl._setAria === "function") ctrl._setAria(false)
    } else {
      const menu = dropdownEl.querySelector("[data-railsui-dropdown-target='menu']")
      if (menu) {
        menu.classList.add("hidden")
        menu.setAttribute("aria-hidden", "true")
      }
    }
  }
}
